export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function twoDigits(d) {
    if (0 <= d && d < 10)
        return '0' + d.toString();
    if (-10 < d && d < 0)
        return '-0' + (-1 * d).toString();
    return d.toString();
}
export function dateToMysqlFormat(d) {
    return (d.getFullYear() +
        '-' +
        twoDigits(1 + d.getMonth()) +
        '-' +
        twoDigits(d.getDate()) +
        ' ' +
        twoDigits(d.getHours()) +
        ':' +
        twoDigits(d.getMinutes()) +
        ':' +
        twoDigits(d.getSeconds()));
}
export function dateToMysqlFormatUTC(d) {
    return (d.getUTCFullYear() +
        '-' +
        twoDigits(1 + d.getUTCMonth()) +
        '-' +
        twoDigits(d.getUTCDate()) +
        ' ' +
        twoDigits(d.getUTCHours()) +
        ':' +
        twoDigits(d.getUTCMinutes()) +
        ':' +
        twoDigits(d.getUTCSeconds()));
}
